module.exports = __webpack_public_path__ + "img/vertical_3_4_7005.8a03667c.png";